const config = require("config");

(function () {
  angular
    .module("app")
    .factory("favoriteLocationsService", [
      "UserProvider",
      "placeCloudService",
      "$q",
      "LocationItem",
      "$http",
      "_",
      function (
        userProvider,
        placeCloudService,
        $q,
        LocationItem,
        $http,
        _
      ) {
        // This set is for new favorites added to the users pcm web set
        const personalSetName = `${userProvider.getUser().account} - ${userProvider.getUser().userName}`;
        let personalFavoritesSetId = -1;
        // pchen: DA place set without Places
        let personalSet;
        // array of PCMWeb LocationItems (1 for each place in above set); populated by loadData
        let personalFavoriteLocations = [];

        // This set is for new favorites added to the accounts pcm web set
        const sharedSetName = userProvider.getUser().account;
        let sharedFavoritesSetId = -1;
        // pchen: DA place set without Places
        let sharedSet;
        // array of PCMWeb LocationItems (1 for each place in above set); populated by loadData
        let sharedFavoriteLocations = [];

        function loadData() {
          // TODO pchen: load favorite places in the background; have "loading..." placeholder in list view
          // sets globals for saving (setids needed for saving new favorites) and viewing favorites
          const personalFavoritesPromise = placeCloudService.getPlaceSetWithName(personalSetName)
            .then(([ firstPlaceSet ]) => {
              personalSet = firstPlaceSet;
              personalFavoritesSetId = (personalSet) ? personalSet.Id : -1;
              return getFavoriteLocationsFromSetId(personalFavoritesSetId, {isSharedFavorite: false});
            }).then(locations => {
              personalFavoriteLocations = locations;
            });
          const sharedFavoritesPromise = placeCloudService.getPlaceSetWithName(sharedSetName, {useShared: true})
            .then(([ firstPlaceSet ]) => {
              sharedSet = firstPlaceSet;
              sharedFavoritesSetId = (sharedSet) ? sharedSet.Id : -1;
              return getFavoriteLocationsFromSetId(sharedFavoritesSetId, {isSharedFavorite: true});
            }).then(locations => {
              sharedFavoriteLocations = locations;
            });

          return $q.all([personalFavoritesPromise, sharedFavoritesPromise]);
        }
        // pchen: isSharedFavorite is only used to set the property in the LocationItem
        function getFavoriteLocationsFromSetId(setId, {isSharedFavorite}) {
          if (setId === -1) {
            // set does not exist (yet)
            return $q.resolve([]);
          } else {
            return placeCloudService.getPlaces(
              setId,
              // filter = ""
              undefined,
              // includePlaces = true
              undefined,
              // readOnlyPublicData
              false
            ).then(placeSet => {
              return placeSet.Places
                .map(daPlace => {
                  // pchen: move this "DAPlace to Personal/Shared Favorite Location" conversion to LocationItem.module?
                  const loc = new LocationItem(daPlace, daPlace.PlaceName);
                  loc.IsShared = isSharedFavorite;
                  return loc;
                });
            });
          }
        }

        function getAllLocations() {
          // pchen: personal favs override shared favs with same name
          return _.union(personalFavoriteLocations, sharedFavoriteLocations, "Name");
        }

        function getAsSets() {
          return {
            personal: _.assign(personalSet, {Places: personalFavoriteLocations}),
            shared: _.assign(sharedSet, {Places: sharedFavoriteLocations})
          }
        }

        function filterOutFavoriteSets(sets) {
          return sets.filter(({Id}) => Id !== personalFavoritesSetId && Id !== sharedFavoritesSetId);
        }


        function saveNew(loc, name, isShared) {
          if (canSave(loc)) {

            loc.Name = name;
            loc.IsShared = isShared === true;
            loc.OnlyMine = true;

            return createDASetIfNeeded(isShared).then(setId => {
              var dataAnywhereCustomPlace = {
                street: loc.ALKObj.Address.StreetAddress,
                city: loc.ALKObj.Address.City,
                state: loc.ALKObj.Address.State,
                zip: loc.ALKObj.Address.Zip,
                latitude: loc.ALKObj.Coords.Lat,
                longitude: loc.ALKObj.Coords.Lon,
                placeName: name,
                county: loc.ALKObj.Address.County
              };

              return placeCloudService.saveNewPlace(setId, null, dataAnywhereCustomPlace).then(resp => {
                loc.Id = resp.Id;
                loc.TypeIcon = "ico-star";
                loc.SetId = setId;
                if (isShared) {
                  sharedFavoriteLocations.push(loc);
                } else {
                  personalFavoriteLocations.push(loc);
                }
              });

            });
          }
        }

        function canSave(loc) {
          if (!userProvider.getUser().isPremium()) {
            return false;
          }
          if ((loc === null) || (loc === undefined)) {
            return false;
          }

          const favs = getAllLocations();

          return ((userProvider.getUser().isLoggedIn) && (_.find(favs, obj => {
            if (loc.ALKObj && Number(obj.ALKObj.Coords.Lat) === Number(loc.ALKObj.Coords.Lat) && //temporary fix @vani @bpan
              Number(obj.ALKObj.Coords.Lon) === Number(loc.ALKObj.Coords.Lon)) {
              return true;
            } else {
              return false;
            }
          }) === undefined));
        }

        function setSavedSetId(respSet, isShared) {
          if (isShared) {
            sharedFavoritesSetId = respSet.Id;
          } else {
            personalFavoritesSetId = respSet.Id;
          }
        }

        function createDASetIfNeeded(isShared) {
          var deferred = $q.defer();
          var setName = isShared ? sharedSetName : personalSetName;

          placeCloudService.getPlaceSetWithName(setName, {useShared: isShared}).then(respSets => {
            if (respSets.length === 0) {
              placeCloudService.addPlaceSet(setName, null, isShared).then(respSet => {
                setSavedSetId(respSet, isShared);
                deferred.resolve(respSet.Id);
              });
            } else {
              var respSet = respSets[0];
              setSavedSetId(respSet, isShared);
              deferred.resolve(respSet.Id);
            }
          });

          return deferred.promise;
        }

        function deleteFavorite(fav) {
          $http.delete(`${config.daUrl}places/${fav.Id}`).success(() => {
            if (fav.isShared) {
              _.remove(sharedFavoriteLocations, fav);
            } else {
              _.remove(personalFavoriteLocations, fav);
            }
          });
        }

        function clearData() {
          personalFavoritesSetId = -1; // This set is for new favorites added to the users pcm web set
          personalFavoriteLocations = [];
          sharedFavoritesSetId = -1; // This set is for new favorites added to the accounts pcm web set
          sharedFavoriteLocations = [];
        }

        return {
          loadData,
          getAllLocations,
          getAsSets,
          filterOutFavoriteSets,
          saveNew,
          canSave,
          deleteFavorite,
          clearData
        }
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/places/favoriteLocations.service.js